import styled from 'styled-components';

const TermsConditionsWrapper = styled.section`
  padding: 0 20px;

  .page-title {
    text-align: center;
    margin-bottom: 20px;
  }

  .introduction {
    text-align: center;
    margin-bottom: 40px;
  }

  .terms-section {
    margin-bottom: 20px;

    .terms-section-text {
      padding-left: 20px;
    }
  }
`;

export default TermsConditionsWrapper;
